import { graphql } from 'gatsby';
import React from 'react';
import Image, { CsAssetSize, getSizesProp } from '../../primitives/image';
import paddingDefault from '../../utils/padding-default';
import Container from '../../primitives/grid/container';
import Link from '../../primitives/link';
import { breakpoints } from '../../primitives/tokens';
import Typography from '../../primitives/typography';

const TeamMembers: React.FC<Queries.TeamMemberGridDataFragment> = (data) => {
    const teamMembers = data?.teamMembers;

    return (
        <section css={paddingDefault()}>
            <Container>
                <ul css={{
                    display: 'grid',
                    gap: '48px',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    [breakpoints.tb]: {
                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    },
                    [breakpoints.mb]: {
                        gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
                    },
                }}
                >
                    {(teamMembers || []).map((member) => {
                        const { companyTitle: job, headshot, title: name, url } = member || {};

                        if (!job || !headshot?.contentStackAsset || !name) {
                            return null;
                        }

                        return (
                            <li
                                css={{
                                    position: 'relative',
                                    paddingTop: '20px',
                                }}
                                key={name}
                            >
                                <Link to={url || '#'}>
                                    <div
                                        css={{
                                            position: 'relative',
                                            marginBottom: '20px',
                                            '&:after': {
                                                display: 'block',
                                                paddingTop: '86%',
                                                content: '""',
                                            },
                                        }}
                                    >
                                        <Image
                                            css={{
                                                position: 'absolute',
                                                top: '0',
                                                left: '0',
                                                height: '100%',
                                                width: '100%',
                                                objectFit: 'cover',
                                            }}
                                            sizes={getSizesProp(CsAssetSize.THIRD_MAX_WIDTH)}
                                            image={headshot as Queries.CsFile}
                                            alt={headshot.title || ''}
                                        />
                                    </div>
                                    <Typography as="h3" fontWeight="medium" color="grey600" fontSize="xl">
                                        {name}
                                    </Typography>
                                    <Typography as="p" fontWeight="medium" color="grey500" css={{ width: '80%' }}>
                                        {job}
                                    </Typography>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </Container>
        </section>
    );
};

export const query = graphql`
    fragment TeamMemberGridData on CsTeamMemberGrid {
        ... on CsTeamMemberGrid {
            teamMembers {
                url
                title
                companyTitle
                headshot {
                    filename
                    title
                    url
                    contentStackAsset(size: THIRD_MAX_WIDTH)
                }
            }
        }
    }
`;

export default TeamMembers;
